import { render } from "./NestedDraggable.vue?vue&type=template&id=66f22623"
import script from "./NestedDraggable.vue?vue&type=script&lang=js"
export * from "./NestedDraggable.vue?vue&type=script&lang=js"

import "./NestedDraggable.vue?vue&type=style&index=0&id=66f22623&lang=css"
script.render = render

export default script